import { Component, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Utilities } from 'src/app/models/utilities';
import { AppCoreService } from 'src/app/services/app-core.service';
import { CustomerService } from 'src/app/services/customer.service';
import { DiscountService } from 'src/app/services/system-config/discount/discount.service';

@Component({
  selector: 'app-period',
  templateUrl: './period.component.html',
  styleUrls: ['./period.component.scss']
})
export class DiscountPeriodComponent {
  @Input() data: any;
  @Input() discountTypes: any[];
  discountPeriodForm: FormGroup;
  isFormSubmitted: boolean;
  showBands = false;
  selectedFile: File | null = null;
  customerList: any[] = [];
  showAccordingDiscountOnInvoice = false;
  showAccordingDiscountOnAmount = false;
  showAccordingDiscountOnWeight = false;
  isCategoryVisible = false;
  isCustomerVisible = false;
  showProgressBar = false;
  progress = 0;
  discountId: number // DiscountPeriod table serial id 
  public context: any;
  currentDate: any;
  Id: number;

  discountTypeList = ['Tariff', 'Bands', 'Contract'];
  categoryList = ['Discount on Invoice', 'Discount on Amount', 'Discount on Weight'];
  bandsList = ['Band 1', 'Band 2', 'Band 3', 'Band 4', 'Band 5', 'Band 6', 'Band 7', 'Band 8', 'Band 9', 'Band 10'];
  useEnterKey: any;

  constructor(
    private appCoreService: AppCoreService,
    private formBuilder: FormBuilder,
    private utilities: Utilities,
    private customerService: CustomerService,
    private discountService: DiscountService,
    public activeModal: NgbActiveModal,
    public modalService: NgbModal,

  ) {
    this.context = { componentParent: this };
  }

  ngOnInit(): void {
    this.currentDate = this.utilities.FormatDateWithTime();
    this.discountPeriodForm = this.formBuilder.group({
      ddlDiscountType: [null, Validators.required],
      ddlCategoryType: [null, Validators.required],
      ddlBands: [null, Validators.required],
      ddlCustomer: [null, Validators.required],

      txtFromDate: [this.currentDate.dateString, Validators.required],
      txtToDate: [this.currentDate.dateString, Validators.required],

      switchFuel: [false],
      switchFreight: [false],
      switchOtherCharges: [false],
      switchVolumetricWeight: [false]
    });
    this.discountPeriodForm.get('ddlDiscountType').disable();
    this.discountPeriodForm.get('txtFromDate').disable();
    this.getAllCustomers();
    this.bindFields(this.data);
    this.onChangeDiscountType();
    this.onChangeCategory();

    const userData = this.appCoreService.GetUserData();
    this.useEnterKey = !userData.metaInfo.tabbasedtemplate;
  }

  ngAfterViewInit(): void {
    this.useEnterKey ? this.utilities.focusFirstElement(this.discountPeriodForm) : null;
  }

  bindFields(cell: any) {
    if (cell) {
      this.discountPeriodForm.patchValue({
        ddlDiscountType:  cell?.type,
        ddlCategoryType : cell?.category,
        ddlBands: cell?.band,
        ddlCustomer : cell?.customerid,
        txtFromDate: cell?.fromdate,
        txtToDate : cell?.todate,
        switchFuel: cell?.isfuelapplied,
        switchFreight : cell?.isfreightapplied,
        switchOtherCharges: cell?.isotherchargesapplied,
        switchVolumetricWeight : cell?.isvolumetricweightapplied,
      });
    }
  }

  onChangeDiscountType() {
    const discountType = this.discountPeriodForm.get('ddlDiscountType').value;

    this.showBands = false;
    this.isCategoryVisible = false;
    this.isCustomerVisible = false;

    this.discountPeriodForm.controls.ddlBands.clearValidators();
    this.discountPeriodForm.controls.ddlCategoryType.clearValidators();
    this.discountPeriodForm.controls.ddlCustomer.clearValidators();

    if (discountType === 'Tariff') {
    }
    else if (discountType === 'Bands') {
      this.showBands = true;
      this.discountPeriodForm.controls.ddlBands.addValidators(Validators.required);
    }
    else if (discountType === 'Contract') {
      this.isCategoryVisible = true;
      this.isCustomerVisible = true;
      this.discountPeriodForm.controls.ddlCategoryType.addValidators(Validators.required);
      this.discountPeriodForm.controls.ddlCustomer.addValidators(Validators.required);
    }

    this.discountPeriodForm.controls.ddlBands.updateValueAndValidity();
    this.discountPeriodForm.controls.ddlCategoryType.updateValueAndValidity();
    this.discountPeriodForm.controls.ddlCustomer.updateValueAndValidity();
  }

  onChangeCategory() {
    const categoryType = this.discountPeriodForm.get('ddlCategoryType').value;

    this.showAccordingDiscountOnAmount = false;
    this.showAccordingDiscountOnWeight = false;

    if (categoryType === 'Discount on Amount') {
      this.showAccordingDiscountOnAmount = true;
    } else if (categoryType === 'Discount on Weight') {
      this.showAccordingDiscountOnWeight = true;
    }
  }

  updateDiscountPeriod() {
    this.isFormSubmitted = true;
    if (this.discountPeriodForm.valid) {
      const reqObj = {
        id: this.Id,
        discounttype: this.discountPeriodForm.get('ddlDiscountType')?.value,
        categorytype: this.discountPeriodForm.get('ddlCategoryType')?.value,
        band: this.discountPeriodForm.get('ddlBands')?.value,
        customerid: this.discountPeriodForm.get('ddlCustomer')?.value,
        fromdate: this.discountPeriodForm.get('txtFromDate')?.value,
        todate: this.discountPeriodForm.get('txtToDate')?.value,
        isfuelapplied: this.discountPeriodForm.get('switchFuel')?.value,
        isfreightapplied: this.discountPeriodForm.get('switchFreight')?.value,
        isotherchargesapplied: this.discountPeriodForm.get('switchOtherCharges')?.value,
        isvolumetricweightapplied: this.discountPeriodForm.get('switchVolumetricWeight')?.value,
      }

      // console.log(" reqObj : ", reqObj)
      this.discountService.UpdateDiscountPeriodById(reqObj).subscribe(res => {
        if (res && res.success) {
          // console.log(" Period data Updated Successfully : ", res)
          this.activeModal.close('Update Discount Period');
        }
      });
    }
  }

  getAllCustomers() {
    try {
      this.customerService.GetAll({ scid: this.appCoreService.GetUserData().selectedServiceCenter }).subscribe((res) => {
        if (res) {
          this.customerList = res.data;
          // console.log("customelist", res.data)
        }
      })
    } catch (error) {
      console.error(error);
    }
  }


}
